<div class="content">
  <!-- This is where dynamic components will be inserted -->
  <div #dynamicContainer class="dynamic-container"></div>
</div>
